import BlueProductFlag from 'src/components/restructure/common/BlueProductFlag/BlueProductFlag'
import {
  PROGRESSIVE_DISCOUNT_EXPERIMENT_ID,
  BUY_TOGETHER_EXPERIMENT_ID,
} from 'src/components/common/StatsigExposure/StatsigExposure'
import { Statsig } from 'src/sdk/statsig'
import Breadcrumb from 'src/components/ui/Breadcrumb'

import { ProductTitle } from './ProductTitle'
import { SellerInformation } from './SellerInformation'
import { SkuSelector } from './SkuSelector'
import { ProductAction } from './ProductAction'
import { LastUnitsFlag } from './LastUnitsFlag'
import { CashbackHighlight } from './CashbackHighlight'
import { CashbackUserInfo } from './CashbackUserInfo/CashbackUserInfo'
import { LearnMoreBikeInsurance } from './LearnMoreBikeInsurance'
import { LearnMoreBikeInsuranceMobile } from './LearnMoreBikeInsurance/LearnMoreBikeInsuranceMobile'
import { useProductPageContext } from '../../contexts'
import FavoritesCounterFull from './ProductPricing/FavoritesCounterFull'
import { GoToSimilars } from './GoToSimilars'
import { FlagNextDayDelivery } from './FlagNextDayDelivery'
import { ProgressiveDiscount } from './ProgressiveDiscount'
import { FlagGuaranteedDelivery } from '../FlagGuaranteedDelivery'
import { CrossSellCard } from './CrossSellCard'
import { CrossSellCardProvider } from './CrossSellCard/cross-sell-card-context'
import ProductAuthorityBadge from '../../ProductCard/ProductAuthorityBadge'
import { ProductPricingExperiment } from './ProductPricing/index'
import { CommercialBenefits } from '../CommercialBenefits'

interface CmsSections {
  id: string
  name: string
  data: Record<string, unknown>
}

type BreadcrumbItem = {
  item: string
  name: string
  position: number
}

type Props = {
  cmsData?: {
    name: string
    sections?: CmsSections[]
  }
  isPdpFirstFoldRevampEnabled?: boolean
  breadcrumbList?: BreadcrumbItem[]
}

export function Sidebar({
  cmsData,
  isPdpFirstFoldRevampEnabled = false,
  breadcrumbList,
}: Props) {
  const { product, currentSku } = useProductPageContext()
  const isProgressiveDiscountEnabled = Statsig.useStatsigFeatureGateValue(
    PROGRESSIVE_DISCOUNT_EXPERIMENT_ID
  )

  const isExperimentalBuyTogether = Statsig.useStatsigFeatureGateValue(
    BUY_TOGETHER_EXPERIMENT_ID
  )

  const {
    sellerDefault: {
      sellerOffer: { lastUnits },
    },
  } = currentSku

  const hasBlueProduct = product?.items?.find((item) =>
    item?.flags?.find((flag) => flag?.value === 'Produto Azul')
  )

  return (
    <>
      <CashbackHighlight />
      <div
        className={
          isPdpFirstFoldRevampEnabled
            ? 'hidden restructure-small-desktop:block'
            : ''
        }
      >
        <ProductTitle />
      </div>
      {currentSku.isAvailable && (
        <FavoritesCounterFull productId={product.productId} />
      )}
      <ProductAuthorityBadge
        product={product}
        className="my-2"
        textClassName="text-xs"
      />
      <LastUnitsFlag isLastUnits={lastUnits} productId={currentSku.productId} />
      {isPdpFirstFoldRevampEnabled && (
        <div className="restructure-small-desktop:hidden">
          <SkuSelector isFirstFoldRevampEnabled={isPdpFirstFoldRevampEnabled} />
        </div>
      )}
      <ProductPricingExperiment />
      <FlagGuaranteedDelivery />
      <GoToSimilars />
      <CashbackUserInfo />
      <FlagNextDayDelivery />
      <div
        className={
          isPdpFirstFoldRevampEnabled
            ? 'hidden restructure-small-desktop:block'
            : ''
        }
      >
        <SellerInformation />
      </div>
      {hasBlueProduct && <BlueProductFlag style="badge" />}
      {!isPdpFirstFoldRevampEnabled && (
        <SkuSelector isFirstFoldRevampEnabled={isPdpFirstFoldRevampEnabled} />
      )}
      {isPdpFirstFoldRevampEnabled && (
        <div className="hidden restructure-small-desktop:block">
          <SkuSelector isFirstFoldRevampEnabled={isPdpFirstFoldRevampEnabled} />
        </div>
      )}
      {isProgressiveDiscountEnabled && <ProgressiveDiscount />}
      <CrossSellCardProvider>
        {isExperimentalBuyTogether && <CrossSellCard />}
        <LearnMoreBikeInsuranceMobile cmsData={cmsData} />
        <ProductAction cmsData={cmsData} />
      </CrossSellCardProvider>
      {isPdpFirstFoldRevampEnabled && breadcrumbList && (
        <div className="restructure-small-desktop:hidden pt-4 pb-4">
          <Breadcrumb breadcrumbList={breadcrumbList} isPdp />
        </div>
      )}
      {isPdpFirstFoldRevampEnabled && (
        <div className="restructure-small-desktop:hidden mt-10">
          <SellerInformation isMobileFirstFoldRevamp />
        </div>
      )}
      {isPdpFirstFoldRevampEnabled && (
        <div className="restructure-small-desktop:hidden mt-2 mb-10 pb-5 border-b border-[#D8D8D8]">
          <CommercialBenefits isMobileFirstFoldRevamp />
        </div>
      )}
      <LearnMoreBikeInsurance cmsData={cmsData} />
    </>
  )
}
